import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
import { logout } from '../../../Redux/actions/auth';
// ##### 25-05-21 Komarov
import AuthIcon from '../Icons/AuthIcon';
import LocalizationNavLink from '../Localization/LocalizationNavLink';
// ##### 24-04-23 Komarov

// ##### Komarov 2025-07-14
const LogInLinkTag = ({ onSmallScreen }) => {
  const dispatch = useDispatch();
  const logOut = () => {
    dispatch(logout());
  };
  // ##### Komarov 2025-08-05
  const signIn = useLocalizedText('sign_in');
  const signOut = useLocalizedText('sign_out');

  const { user: currentUser } = useSelector(state => state.auth);

  return (
    <div
      // ##### Komarov 2025-07-23
      id="id_logInDivTagSsr"
      style={{
        padding: '1vw',
      }}
      key={uniqueId()}
    >
      {parseInt(currentUser.user_id) !== 1426 ? (
        <LocalizationNavLink
          exact
          to={''}
          activeClassName="active"
          onClick={logOut}
        >
          {/* ##### 23-04-01 Komarov TODO: Прислать сюда перевод из Смарта */}
          <AuthIcon
            key={uniqueId()}
            color={(!onSmallScreen && 'white') || '#102D69'}
            hintText={parse(signOut)}
            onSmallScreen={onSmallScreen}
            type="signout"
          />
        </LocalizationNavLink>
      ) : (
        <LocalizationNavLink
          // exact to={`/sign_in`}
          // ##### 25-04-21 Komarov
          // to={`/profile/?name=${signIn.name}&spid=${signIn.id}`}
          to={'/profile/?name=sign_in&spid=198'}
          activeClassName="activeMenuLinks"
        >
          {/* ##### 22-08-29 Komarov: убрал вывод спецсимволов HTML в пунктах меню в мобильном устройстве: отправил текст пунктов в функцию parse */}
          {/* ##### 23-04-01 Komarov */}
          <AuthIcon
            key={uniqueId()}
            color={(!onSmallScreen && 'white') || '#102D69'}
            hintText={parse(signIn)}
            onSmallScreen={onSmallScreen}
            type="signin"
          />
        </LocalizationNavLink>
      )}
    </div>
  );
};

// ##### 25-05-21 Komarov
export default LogInLinkTag;
